import { z } from "zod";
import { Id, IsoDateTime } from "./common.ts";

export const ReportReason = z.enum([
  "harassment",
  "inappropriate_message",
  "underage",
  "safety_concern",
  "spam",
  "other",
]);
export type ReportReason = z.infer<typeof ReportReason>;

/** `ModerationReport` lifecycle. Spec-locked to _spec-backbone.md §4. */
export const ModerationStatus = z.enum([
  "submitted",
  "triaged",
  "actioned",
  "dismissed",
  "escalated",
]);
export type ModerationStatus = z.infer<typeof ModerationStatus>;

export const ModerationReport = z.object({
  id: Id,
  sessionId: Id,
  reporterCustomerId: Id.optional(),
  subjectCustomerId: Id.optional(),
  subjectTableId: Id.optional(),
  reason: ReportReason,
  details: z.string().max(500).optional(),
  status: ModerationStatus,
  createdAt: IsoDateTime,
  resolvedAt: IsoDateTime.optional(),
});
export type ModerationReport = z.infer<typeof ModerationReport>;

export const CreateReport = ModerationReport.pick({
  subjectCustomerId: true,
  subjectTableId: true,
  reason: true,
  details: true,
});
export type CreateReport = z.infer<typeof CreateReport>;
